import { render, staticRenderFns } from "./IconCheckOnSolid.vue?vue&type=template&id=864b99ec&"
import script from "./IconCheckOnSolid.vue?vue&type=script&lang=ts&"
export * from "./IconCheckOnSolid.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports